// extracted by mini-css-extract-plugin
module.exports = {"tileWH":"9%","tileContainerWH":"12%","tileContainerLengthMobile":"16%","goButton":"GoButton_goButton__2syLH"};